/**
 * Created by Ning Jiang on 2021-05-06.
 */

export enum ReelState {
    IDLE = "idle",
    INACTIVE = "inactive",

    // Spin states.
    START = "start",
    SPIN = "spin", // When avalanche, it doesn't nothing, mark for the time after drop_out before new drop_in.
    STOPPING = "stopping",
    BOUNCE = "bounce",
    STOPPED = "stopped",
    NUDGE = "nudge",

    // Avalanche states.
    ALL_OUT = "all_out", // When start a new spin, everything drop out.
    AVALANCHE_START = "avalanche_start", // When start a avalanche.
    ALL_IN = "all_in", // When start a new spin, all new symbols drop in.
    AVALANCHE = "avalanche", // when avalanche,  the current left symbols fall down if the symbol below is gone.
    AVALANCHE_NEW = "avalanche_new", // After AVALANCHE, new symbols come in to fill up the area.
}

export interface IReelStateEventData {
    reelId:number;
    newState:ReelState;
    oldState:ReelState;
    disabled?:boolean;
}